export const ssoFieldTypes = {
    EmailAddress: 0,
    Username: 1,
    ConfirmEmailAddress: 2,
    OldPassword: 3,
    Password: 4,
    ConfirmPassword: 5,
    Title: 6,
    FirstName: 7,
    LastName: 8,
    DateOfBirth: 9,
    AddressLine1: 10,
    AddressLine2: 11,
    AddressLine3: 12,
    Postcode: 13,
    MobilePhone: 14,
    City: 15,
    Country: 16,
    County: 17,
    MainAddress: 18,
    ShippingAddress: 19,
    BillingAddress: 20,
    FavoritePlayer: 21,
    Venues: 22,
    Consent: 23,
    OffersDetails: 24,
    AcceptOffers: 25,
    OffersConsent: 26,
    RefuseOffers: 27,
    Policy: 28,
    PrivacyPolicy: 29,
    OneClubTermsAndServices: 30,
    ContactDetails: 31,
    VerificationCode: 32,
    BecomeOneClubMember: 33,
    SelectOption: 34,
    MultipleChoiceOption: 35,
    LookupSuggestion: 36,
    FrequentlyAskedQuestion: 37,
    HTMLText: 38,
    BecomeOneClubMemberInfo: 39,
    MainAddressLabel: 40,
    ChampionshipSection: 41,
    ChannelSection: 42,
    InterestSection: 43,
    RaMemberId: 44,
    Captcha: 45,
    Mastercard: 46,
    State: 47,
    TextAndImageTile: 48
};
